import { UseGqlMutationCallbacks, useMutationWithInvalidation } from '@alice-financial/api'
import { useMutationNotifier } from '../../../../notifications/useMutationNotifier'
import { useOrderFormAcceptanceQuery, useTosAcceptanceQuery } from '../../documents'
import {
  RequestOrderFormAcceptanceMutation,
  useRequestOrderFormAcceptanceMutation,
} from './requestOrderFormAcceptance_gen'

type RequestOrderFormAcceptanceMutationOptions = UseGqlMutationCallbacks<RequestOrderFormAcceptanceMutation>
export const useRequestOrderFormAcceptance = (
  { ownerId, accepterId }: { ownerId: number; accepterId: number },
  mutationOptions?: RequestOrderFormAcceptanceMutationOptions
) => {
  const { mutateAsync: requestOrderFormAcceptance } = useRequestOrderFormAcceptanceMutation()
  const optionsWithNotifier = useMutationNotifier({ onSuccess: false }, mutationOptions)
  return useMutationWithInvalidation(
    () => requestOrderFormAcceptance({ ownerId, accepterId }),
    optionsWithNotifier,
    [useOrderFormAcceptanceQuery.getKey({ ownerId, accepterId }), useTosAcceptanceQuery.getKey({ ownerId })]
  )
}
